import React from 'react'
import { useIntl } from 'react-intl'
import { connect } from 'react-redux'
import { Button, Tooltip } from 'antd'
import { SunFilled, SunOutlined } from '@ant-design/icons'

const mapStateToProps = ({ settings }) => ({ altoContraste: settings.altoContraste })

const AltoContraste = ({ altoContraste, dispatch }) => {
  const intl = useIntl()
  const texto = intl.formatMessage({ id: 'topBar.altoContraste' })

  const toggle = () => {
    dispatch({
      type: 'settings/SET_ALTO_CONTRASTE',
      payload: { altoContraste: !altoContraste },
    })
  }

  return (
    <Tooltip title={texto}>
      <Button
        type={altoContraste ? 'primary' : 'default'}
        icon={altoContraste ? <SunOutlined /> : <SunFilled />}
        aria-label={texto}
        aria-pressed={altoContraste}
        onClick={toggle}
      />
    </Tooltip>
  )
}

export default connect(mapStateToProps)(AltoContraste)
